import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { LoginDto } from "~/data/user/login.dto";

import { login } from "~/data/user/user.service";

import { Field } from "../shared/field";
import { Button } from "../shared/button";
import { Input, InputPassword } from "../shared/input";

export function Login() {
  const navigate = useNavigate();
  const form = useForm<LoginDto>();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (dto: LoginDto) => login(dto),
    onSuccess: (data) => queryClient.setQueryData(["user"], data),
  });
  const onSubmit = form.handleSubmit((data) =>
    mutation.mutate(data, {
      onSuccess: (user) => {
        const greetingAudioUrl = user.greetings_message_url;
        if (greetingAudioUrl) {
          const audio = new Audio(
            import.meta.env.VITE_API_URL + greetingAudioUrl
          );
          audio.play();
        }

        try {
          const redirect = sessionStorage.getItem("redirect") ?? "";
          sessionStorage.removeItem("redirect");
          const redirectUrl = new URL(redirect);
          navigate(redirectUrl.pathname + redirectUrl.search);
        } catch {
          navigate("/");
        }
      },
    })
  );

  return (
    <form onSubmit={onSubmit} className="flex flex-col items-center w-full">
      <h2 className="text-primary-1 text-2xl lg:text-3xl font-semibold mb-5 lg:mb-10 text-center">
        Acesse sua conta
      </h2>

      <div className="w-[460px] max-w-full">
        <Field className="mb-2" label="E-mail">
          <Input
            {...form.register("email", { required: "Campo obrigatório" })}
            placeholder="Informe um e-mail válido"
            type="email"
          />
        </Field>

        <Field label="Senha" className="mb-1">
          <InputPassword
            {...form.register("password", {
              required: "Campo obrigatório",
            })}
            placeholder="8 dígitos, letras, números e caracteres especiais."
          />
        </Field>

        <p className="w-full text-end mb-5 lg:mb-10">
          <Link
            className="hover:underline text-primary-1 text-sm"
            to="/recuperar-senha"
          >
            Esqueci minha senha
          </Link>
        </p>
      </div>

      <Button
        className="h-10 w-60 max-w-full my-5"
        loading={mutation.isPending}
        type="submit"
        variant="primary-1"
      >
        Entrar
      </Button>

      <Button
        className="h-10 w-60 max-w-full mb-10"
        asChild
        variant="primary-1"
      >
        <Link to="/cadastrar">Registrar</Link>
      </Button>
    </form>
  );
}
